import React, { useEffect, useState } from "react";
import { Box, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";

/**
 * Fullscreen-style preview for profile / avatar photos.
 */
export default function ProfileImagePreview({
  open,
  src,
  alt = "Profile photo",
  onClose,
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src, open]);

  return (
    <Dialog
      open={Boolean(open) && Boolean(src)}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          m: 2,
          maxWidth: "min(920px, 96vw)",
          maxHeight: "92vh",
          borderRadius: 3,
          overflow: "hidden",
          bgcolor: "#0f172a",
        },
      }}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(15, 23, 42, 0.72)" },
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 1.5,
          py: 1,
          borderBottom: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
          <ZoomOutMapIcon sx={{ color: "rgba(255,255,255,0.75)", fontSize: 18 }} />
          <Typography
            sx={{
              color: "rgba(255,255,255,0.9)",
              fontSize: 13,
              fontWeight: 600,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {alt || "Photo preview"}
          </Typography>
        </Box>
        <IconButton
          aria-label="Close preview"
          onClick={onClose}
          size="small"
          sx={{ color: "rgba(255,255,255,0.85)" }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 1.5, sm: 2.5 },
          minHeight: { xs: 280, sm: 420 },
          maxHeight: "calc(92vh - 56px)",
          overflow: "auto",
        }}
        onClick={onClose}
      >
        {failed || !src ? (
          <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: 14 }}>
            Photo could not be loaded.
          </Typography>
        ) : (
          <Box
            component="img"
            src={src}
            alt={alt}
            onClick={(e) => e.stopPropagation()}
            onError={() => setFailed(true)}
            sx={{
              maxWidth: "100%",
              maxHeight: "calc(92vh - 100px)",
              objectFit: "contain",
              borderRadius: 2,
              boxShadow: "0 16px 48px rgba(0,0,0,0.45)",
              cursor: "default",
            }}
          />
        )}
      </Box>
    </Dialog>
  );
}
